<template>
  <nav class="navbar" :class="{ 'navbar-scroll': isNavbarScrolled }">
    <router-link to="/">
      <img :src="logo" alt="Logo" style="height: 35px;">
    </router-link>
    <router-link to="/about">About</router-link>
    <router-link to="/skillset">Skillset</router-link>
    <router-link to="/projects">Projects</router-link>
  </nav>
  <router-view/>
</template>

<script>
import logo from '@/assets/logo.png';
import { VueMetaPlugin } from 'vue-meta';

export default {
  name: 'Navbar',
  metaInfo: {
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0',
      },
    ],
  },
  data() {
    return {
      logo,
      isNavbarScrolled: false,
      scrollTimeout: null,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
  },
  methods: {
    handleScroll() {
      this.isNavbarScrolled = window.scrollY > 0;
      // Clear the timeout if it's already set
      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
      // Set a timeout to check if scrolling has stopped
      this.scrollTimeout = setTimeout(() => {
        this.isNavbarScrolled = false;
      }, 300); // The timeout should match the duration of the opacity transition
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 50px;
  background-color: #fff;
  transition: background-color 0.3s, box-shadow 0.3s, color 0.3s, opacity 0.3s;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.05); /* Adjusted to show only on the bottom */
}

.navbar a {
  font-weight: bold;
  text-decoration: none;
  padding: 10px 15px;
  margin: 0 15px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  height: 35px;
  box-sizing: border-box;
  transition: color 0.3s, background-color 0.3s;
}

.navbar a:not(.router-link-exact-active):hover {
  color: #004ac0;
  background-color: #f0f0f0;
}

.navbar a.router-link-exact-active {
  color: #004ac0;
}

@media (max-width: 600px) {
  .navbar {
    flex-direction: row;
    padding-top: 10px;
    padding-bottom: 20px;
  }

  .navbar a {
    font-size: 0.8rem;
    margin: 5px 0;
  }
}

/* Adding a box-shadow on scroll */
.navbar-scroll {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.03);
  opacity: 0.55;
}

/* Ensuring the color is consistent */
.navbar-scroll a,
.navbar-scroll img {
  color: #4f4f4f !important;
}

.navbar-scroll a.router-link-exact-active {
  color: #004ac0 !important;
}

</style>
